import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useField } from "@unform/core";
import { Container, LabelContainer, MessageError } from "./styles";

export interface CurrencyInputStringProps {
    name: string;
    label?: string;
    readOnly?: boolean;
    disabled?: boolean;
    className?: string;
    defaultValue?: string;
    prefix?: string;
    placeholder?: string;
}

export function CurrencyInputString({
    name,
    label,
    className,
    defaultValue,
    prefix = "R$ ",
    placeholder = "Digite um valor",
    ...rest
}: CurrencyInputStringProps) {
    const inputRef = useRef(null);
    const [inputValue, setInputValue] = useState<string>(defaultValue || "");

    const { fieldName, registerField, error, clearError } = useField(name);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            getValue() {
                return inputValue;
            },
            setValue(_, value) {
                setInputValue(value);
            },
            clearValue() {
                setInputValue("");
            },
        });
    }, [fieldName, registerField, inputValue]);

    return (
        <Container className={className}>
            {(label || error) && (
                <LabelContainer>
                    {error ? (
                        <MessageError>{error}</MessageError>
                    ) : (
                        <p className="text-sm text-teal-800">{label}</p>
                    )}
                </LabelContainer>
            )}
            <NumericFormat
                getInputRef={inputRef}
                decimalScale={2}
                decimalSeparator=","
                thousandSeparator="."
                prefix={prefix}
                name={name}
                value={inputValue}
                placeholder={placeholder}
                onValueChange={({ formattedValue }) =>
                    setInputValue(formattedValue)
                }
                onFocus={clearError}
                {...rest}
            />
        </Container>
    );
}
